/*
=========================================================
ASSABOOR ENTERPRISE
CART NOTIFICATION V1
File: assets/ae-cart-notification.js
=========================================================
*/

(() => {
    'use strict';

    class AECartNotification {

        constructor() {

            this.notification = document.querySelector(
                '[data-ae-cart-notification]'
            );

            if (!this.notification) {
                return;
            }

            this.title = this.notification.querySelector(
                '[data-ae-cart-notification-title]'
            );

            this.meta = this.notification.querySelector(
                '[data-ae-cart-notification-meta]'
            );

            this.closeButton = this.notification.querySelector(
                '[data-ae-cart-notification-close]'
            );

            this.checkoutButton = this.notification.querySelector(
                '[data-ae-cart-notification-checkout]'
            );

            this.timeout = null;

            this.bindEvents();
        }

        bindEvents() {

            if (this.closeButton) {
                this.closeButton.addEventListener(
                    'click',
                    () => this.hide()
                );
            }

            if (this.checkoutButton) {
                this.checkoutButton.addEventListener(
                    'click',
                    () => {
                        window.location.href = '/checkout';
                    }
                );
            }

            document.addEventListener(
                'ae:cart:added',
                (event) => {

                    const detail = event.detail || {};

                    this.show({
                        title: detail.title || 'Added to cart',
                        meta: detail.meta || ''
                    });

                }
            );

        }

        show(data = {}) {

            if (!this.notification) {
                return;
            }

            if (this.title) {
                this.title.textContent =
                    data.title || 'Added to cart';
            }

            if (this.meta) {

                if (data.meta) {

                    this.meta.textContent = data.meta;
                    this.meta.hidden = false;

                } else {

                    this.meta.textContent = '';
                    this.meta.hidden = true;

                }

            }

            this.notification.classList.add(
                'is-visible'
            );

            this.notification.setAttribute(
                'aria-hidden',
                'false'
            );

            clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {

                this.hide();

            }, 5000);

        }

        hide() {

            if (!this.notification) {
                return;
            }

            this.notification.classList.remove(
                'is-visible'
            );

            this.notification.setAttribute(
                'aria-hidden',
                'true'
            );

            clearTimeout(this.timeout);

        }

    }

    function initialise() {

        window.AssaboorCartNotification =
            new AECartNotification();

    }

    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            initialise,
            { once: true }
        );

    } else {

        initialise();

    }

})();